import styled, { css } from 'styled-components';
import base from './base';

const ChunkStyled = styled.div`
  ${base};
  ${(props) =>
    props.bgColor &&
    css`
      background: ${props.bgColor === 'white' ? 'rgba(255, 255, 255, .95)' : 'black'};
    `};
`;

export default ChunkStyled;
